export default __webpack_public_path__ + "static/media/mobile-icon.fcc1a2ef.svg";